export const CLIENT_SIDE_MESSAGES = {
	SERVER_ERROR: "server error please try again",
	BIFROST_FILE_UPLOAD_SUCCESS_MESSAGE: "- Your files are getting uploaded.. you can wait for some time or visit this page later on.",
	BIFROST_FILE_EXTRACT_SUCCESS_MESSAGE: "- Your files are getting extracted.. you can wait for some time or visit this page later on..",
}
